import { IRequestClient } from "../../../types/client.interface";
import customAxios from "../../customAxios";
import { FIND_CLIENT } from "../../routes";
// import {ADMIN_ALL_SERVICE} from "../../routes";

const findClient = async (props: IRequestClient) => {
  console.log(props);

  var thisUrl = FIND_CLIENT + "?";
  if (props.page) thisUrl += `page=${props.page}`;
  if (props.limit) thisUrl += `&limit=${props.limit}`;
  if (props.county) thisUrl += `&county=${props.county}`;

  if (props?.search && props.search.value !== "") {
    thisUrl += `&${props.search.base}=${props.search.value}`;
  }

  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ FIND_CLIENT: error });
  }
};

export default findClient;
